import { setMedianBackFriendlyNavigationTitle } from './medianBridge';

export const isMedian = () => {
  if (typeof window === 'undefined' || !window.navigator || !window.navigator.userAgent) {
    return false;
  }

  const ua = window.navigator.userAgent.toLowerCase();
  return ua.includes('median') || ua.includes('gonative');
};

export const hardNavigate = (url) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (isMedian()) {
    setMedianBackFriendlyNavigationTitle().catch(() => null);
  }

  window.location.assign(url);
};
